﻿import { IComponent, Component, Inject, Input, Output, Attribute, OutputArgs } from "@fiqas/angular-utils";
import { FIQAssist } from "../../app";
import { Application } from "../../components/application"
import { DropdownEntry } from "../../controls/dropdownbox";
import { IDisposable } from "../../interfaces/general";
import { LogService } from "../../services/logService";

@Component({
    module: FIQAssist,
    selector: "customerchecklistcombo",
    template: `
            <checklistcombo
                value-sumbit="$ctrl.passValueSubmit(selected)"
                read-only="$ctrl.readOnly"
                ng-visible = "$ctrl._items.length > 1"
                onselectionchanged="$ctrl.selectionChanged(selected)"
                items="$ctrl._items"
                showAllOption="false"
                all-selected-text="$ctrl.ALL_CUSTOMERS_SELECTED | translate "
                multiple-selected-text="$ctrl.MULTIPLE_CUSTOMERS_SELECTED | translate"
                none-selected-text="''"
                selected="$ctrl.customerKeys"
                show-clear="{{$ctrl.showClear}}"
                ></checklistcombo>`,
    require: {
        "application": "^application"
    }
})
class CustomerChecklistCombo<T> implements IComponent {
    @Input() public readOnly: boolean;
    public application: Application;
    private disposables: IDisposable[] = [];
    private _customerKeys: string[];
    private _items: any[];
    private _showClear;

    private MULTIPLE_CUSTOMERS_SELECTED = "MULTIPLE_CUSTOMERS_SELECTED";
    private ALL_CUSTOMERS_SELECTED = "ALL_CUSTOMERS_SELECTED";

    @Input() public get customerKeys(): string[] {
        return this._customerKeys;
    }
    public set customerKeys(keys: string[]) {
        if ((!keys || keys.length == 0) && this._items) {
            this._items.forEach(item => item.checked = false);
        }
        this._customerKeys = keys;
    }

    constructor(
        @Inject('$timeout') private $timeout: ng.ITimeoutService,
        @Inject() private logService: LogService,
        @Inject('$rootScope') private $rootScope: angular.IRootScopeService
    ) {}

    $onInit() {
        this.update(this.application.selectedCustomers);
        this.disposables.push(this.application.addOnAccountsChanged(s => this.update(s)));

        this.$rootScope.$on('eventCleared', (event) => {
            this.update(this.application.selectedCustomers);
        });
    }

    private update(sel: { key: T, text: string }[]) {
        this.showClear = true;
        this._items = sel.map((x) => <DropdownEntry<T>>{ key: x.key, text: x.text });
        if (this._items.length > 1) {
            this.customerKeys = [];
        }
        else if (this._items.length == 1) {
            this.showClear = false;
            this._items[0].checked = true;
        }
    }

    @Attribute() public get showClear() {
        return this._showClear;
    }
    public set showClear(val: boolean | string) {
        this._showClear = val === true || val === "true";
    }

    @Output() public onCustomersChanged: OutputArgs<{ customerKeys: any[] }>;

    public selectionChanged(selected: string[]) {
        this.customerKeys = selected.map((x) => x['key']);
        this.onCustomersChanged({customerKeys: this.customerKeys });
    }

    @Output() public valueSubmit: OutputArgs<{ customerKeys: any[] }>;
    public passValueSubmit(selected: any[]) {
        this.customerKeys = selected.map((x) => x['key']);
        if (this.valueSubmit) {
            this.valueSubmit({ customerKeys: this.customerKeys });
        }
    }

    $onDestroy() {
        this.disposables.forEach(d => {
            try { d() } catch (e) { this.logService.warning('CustomerChecklistCombo', "Error while disposing", e); }
        });
    }
}
